/**
 * DotLineMenuIcon component - renders a dot line menu icon as SVG
 * @returns React component that renders the dot line menu icon
 */
const DotLineMenuIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.23288 4.94083C3.91378 4.94083 4.46575 4.39443 4.46575 3.72041C4.46575 3.0464 3.91378 2.5 3.23288 2.5C2.55198 2.5 2 3.0464 2 3.72041C2 4.39443 2.55198 4.94083 3.23288 4.94083Z"
        fill="#616161"
      />
      <path
        d="M13.1822 4.53402H6.29041C5.83836 4.53402 5.46849 4.1679 5.46849 3.72041C5.46849 3.27293 5.83836 2.9068 6.29041 2.9068H13.1781C13.6301 2.9068 14 3.27293 14 3.72041C14 4.1679 13.6301 4.53402 13.1781 4.53402H13.1822Z"
        fill="#616161"
      />
      <path
        d="M3.23288 9.22041C3.91378 9.22041 4.46575 8.67402 4.46575 8C4.46575 7.32598 3.91378 6.77959 3.23288 6.77959C2.55198 6.77959 2 7.32598 2 8C2 8.67402 2.55198 9.22041 3.23288 9.22041Z"
        fill="#616161"
      />
      <path
        d="M9.68493 8.81361H6.29041C5.83836 8.81361 5.46849 8.44748 5.46849 8C5.46849 7.55252 5.83836 7.18639 6.29041 7.18639H9.68493C10.137 7.18639 10.5068 7.55252 10.5068 8C10.5068 8.44748 10.137 8.81361 9.68493 8.81361Z"
        fill="#616161"
      />
      <path
        d="M3.23288 13.5C3.91378 13.5 4.46575 12.9536 4.46575 12.2796C4.46575 11.6056 3.91378 11.0592 3.23288 11.0592C2.55198 11.0592 2 11.6056 2 12.2796C2 12.9536 2.55198 13.5 3.23288 13.5Z"
        fill="#616161"
      />
      <path
        d="M12.0151 13.0932H6.29041C5.83836 13.0932 5.46849 12.7271 5.46849 12.2796C5.46849 11.8321 5.83836 11.466 6.29041 11.466H12.0151C12.4671 11.466 12.837 11.8321 12.837 12.2796C12.837 12.7271 12.4671 13.0932 12.0151 13.0932Z"
        fill="#616161"
      />
    </svg>
  );
};

export default DotLineMenuIcon;
